import { cn } from "@kit/ui/utils";

interface LineProps {
  className?: string;
}

export const Line = ({ className }: LineProps) => {
  return (
    <div className={cn("flex gap-6 w-full", className)}>
      <div className="h-[1px] w-full bg-white/20 rounded-full"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="4" viewBox="0 0 5 4" fill="none">
        <circle cx="2.50005" cy="2.00005" r="2.00005" fill="white" fillOpacity="0.2"/>
      </svg>
      <div className="h-[1px] w-full bg-white/20 rounded-full"></div>
    </div>
  );
}